export default "__VITE_ASSET__BS7cyN7C__"